import moment from 'moment/min/moment-with-locales';
import { defaultLocale, getTranslation, locale } from './translation';

const langPack = {
    aze: 'az',
    eng: 'en',
};

if (locale === 'aze') {
    moment.updateLocale('az', {
        monthsShort: getTranslation('shortMonths'),
        weekdaysShort: getTranslation('shortDays'),
    });
}

export const localeMoment = (locale = defaultLocale) => {
    moment.locale(langPack[locale.toLowerCase()]);

    return moment;
};
